import PropTypes from 'prop-types';
import { useId } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

const DropDownInput = ({
  helper,
  label,
  error,
  options = [],
  value,
  ...props
}) => {
  const labelId = useId();
  const inputId = useId();
  return (
    <FormControl hiddenLabel={!label} variant='filled' error={error} fullWidth>
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <Select
        id={inputId}
        labelId={labelId}
        value={value || ''}
        {...props}
      >
        {options && options.map && options.map(({ value, label }, index) => (
          <MenuItem key={`select-menuItem-${index}`} value={value}>{label}</MenuItem>
        ))}
      </Select>
      <FormHelperText>{helper}</FormHelperText>
    </FormControl>
  );
};

DropDownInput.propTypes = {
  helper: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  options: PropTypes.array,
};

export default DropDownInput;
